import { useState, useEffect } from 'react';
import { keyBy } from 'lodash';
const useTableDataLoader = (api, path, searchParam, visible = true, isInMailAPage = false) => {
    const [tableList, setTableList] = useState([]);
    const [tableMap, setTableMap] = useState();
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState(1);
    const [hasContent, setHasContent] = useState(false);
    const [total, setTotal] = useState(0);
    const [expandKeys, setExpandKeys] = useState([]);
    useEffect(() => {
        if (!visible)
            return;
        if (isInMailAPage) {
            requestEDMTableData();
        }
        else {
            requestWaTableData();
        }
    }, [searchParam, visible, isInMailAPage]);
    const requestEDMTableData = () => {
        setLoading(true);
        api[path](searchParam).then((data) => {
            const { totalCount, page } = data;
            const productDetailList = data.productDetailList || [];
            if (data.totalCount > 0) {
                try {
                    productDetailList.forEach((product) => {
                        if (product.pictures) {
                            try {
                                product.pictures = JSON.parse(product.pictures);
                            }
                            catch (_a) { }
                        }
                    });
                }
                catch (_a) { }
                const template = [];
                const _productDetailList = productDetailList.map((item) => {
                    const { productStockList = [] } = item;
                    productStockList.forEach((s) => {
                        s.tempId = (s === null || s === void 0 ? void 0 : s.stockId) ? s.stockId : '';
                        if (s.pictures) {
                            try {
                                s.pictures = JSON.parse(s.pictures);
                            }
                            catch (_a) { }
                        }
                    });
                    if (productStockList.length) {
                        template.push(item.id);
                    }
                    return Object.assign(Object.assign({}, item), { stockLength: item.productStockList.length, isSPU: true, tempId: item.id });
                });
                const result = [];
                _productDetailList.forEach((item) => {
                    if (item.productStockList.length > 0) {
                        item.productStockList.forEach((stockItem) => {
                            result.push(stockItem);
                        });
                    }
                });
                const newdata = _productDetailList.concat(result).sort((a, b) => {
                    if (a.isSPU === true && b.isSPU !== true) {
                        return -1;
                    }
                    return 0;
                });
                setCurrent(page);
                setTotal(totalCount);
                setTableList(_productDetailList);
                setHasContent(true);
                setTableMap(keyBy(newdata, 'tempId'));
                setExpandKeys(template);
            }
            else {
                setHasContent(false);
            }
            setLoading(false);
            console.log('请求数据-table-api', data);
        });
    };
    const requestWaTableData = () => {
        setLoading(true);
        api[path](searchParam).then((data) => {
            const { totalCount, page } = data;
            const productDetailList = data.productDetailList || [];
            if (data.totalCount > 0) {
                try {
                    productDetailList.forEach((product) => {
                        if (product.pictures) {
                            try {
                                product.pictures = JSON.parse(product.pictures);
                            }
                            catch (_a) { }
                        }
                    });
                }
                catch (_a) { }
                setCurrent(page);
                setTotal(totalCount);
                setTableList(productDetailList);
                setHasContent(true);
                setTableMap(keyBy(productDetailList, 'id'));
            }
            else {
                setHasContent(false);
            }
            setLoading(false);
            console.log('请求数据-table-api', data);
        });
    };
    useEffect(() => {
        return () => {
            setLoading(false);
            setCurrent(1);
            setHasContent(false);
            setTotal(0);
            setTableList([]);
            setTableMap({});
        };
    }, []);
    return {
        tableList,
        tableMap,
        loading,
        total,
        hasContent,
        requestTableData: isInMailAPage ? requestEDMTableData : requestWaTableData,
        current,
        expandKeys,
    };
};
export default useTableDataLoader;
